import styled from '@emotion/styled';
import { IconButton } from '@travelnest/merlin.button-icon';
import * as React from 'react';
import * as ReactDOM from 'react-dom';

interface IExpandingMenuState {
	expanded: boolean;
	offscreen: boolean;
}

const StyledIconButton = styled(IconButton)`
	height: 40px;
	width: 40px;
	margin-right: 10px;
`;

export class ExpandingMenu extends React.Component<React.PropsWithChildren, IExpandingMenuState> {

	constructor(props: {}) {
		super(props);
		this.state = { expanded: false, offscreen: false };
		this.setOffscreen = this.setOffscreen.bind(this);
	}

	public isOffscreen() {
		const node = ReactDOM.findDOMNode(this);
		if (node instanceof HTMLElement) {
			const position = node.getBoundingClientRect();

			// checking for partial visibility
			if (position.right + 200 > window.innerWidth) {
				return true;
			}
		}
		return false;
	}

	public setOffscreen() {
		this.setState({ offscreen: this.isOffscreen() });
	}

	public componentDidMount() {
		this.setOffscreen();
		window.addEventListener('resize', this.setOffscreen);
	}

	public componentWillUnmount() {
		window.removeEventListener('resize', this.setOffscreen);
	}

	public render() {
		const { children } = this.props;
		return <div className="expanding-menu">
			<StyledIconButton
				icon={this.state.expanded ? 'up' : 'down'}
				iconPosition="center"
				colour="darkGrey"
				onClick={() => this.setState({ expanded: !this.state.expanded })} />
			{this.state.expanded && <div className={`expanding-menu-tray${this.state.offscreen ? ' expanding-menu-tray-left' : ''}`}>
				{children}
			</div>}
		</div>;
	}
}
